var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 24,
    viewBox: "0 0 17 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7857 3.2L12.3325 2.1847C12.0107 1.46407 11.2954 1 10.5062 1H3C1.89543 1 1 1.89543 1 3V21C1 22.1046 1.89543 23 3 23H10.5062C11.2954 23 12.0107 22.5359 12.3325 21.8153L12.7857 20.8",
    stroke: "#FF9924",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6553 11.4697C16.9482 11.7626 16.9482 12.2375 16.6553 12.5304L11.8824 17.3034C11.5895 17.5963 11.1146 17.5963 10.8217 17.3034C10.5288 17.0105 10.5288 16.5356 10.8217 16.2427L15.0643 12.0001L10.8217 7.75742C10.5288 7.46453 10.5288 6.98965 10.8217 6.69676C11.1146 6.40387 11.5895 6.40387 11.8824 6.69676L16.6553 11.4697ZM5.32143 12.7501C4.90722 12.7501 4.57143 12.4143 4.57143 12.0001C4.57143 11.5858 4.90722 11.2501 5.32143 11.2501V12.7501ZM16.125 12.7501H5.32143V11.2501H16.125V12.7501Z",
    fill: "#FF9924"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignout);
export default __webpack_public_path__ + "static/media/signout.b8cc8e09e0ee07a9b99a95fcbc507301.svg";
export { ForwardRef as ReactComponent };